import React from "react";
import { ChevronIcon } from "./ChevronIcon";

export const ChevronDownIcon = (props: React.ComponentProps<typeof ChevronIcon>) => <ChevronIcon {...props} direction="down" />;
